import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareDescriptionAttributePropertyValues =
    AttributePropertyValues
    & {
        description: string;
    };

export type ClientAwareDescriptionAttributeProperties = {
    [name in keyof ClientAwareDescriptionAttributePropertyValues]?: ClientAwareDescriptionAttributePropertyValues[name];
};

export interface IClientAwareDescriptionAttribute extends IAttribute, ClientAwareDescriptionAttributeProperties
{
}

export class ClientAwareDescriptionAttribute extends Attribute implements IClientAwareDescriptionAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareDescriptionAttribute";
    public static override className = "ClientAwareDescriptionAttribute";

    public description?: string;

    constructor(propertyValues?: Partial<ClientAwareDescriptionAttributePropertyValues>)
    {
        super(propertyValues);

        this.description = propertyValues?.description;
    }
}